import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useLogin: undefined;
	useLogout: undefined;
}

const AUTH_SERVICE_KEYS = createReactQueryKeys<KeyTypes>("auth", [
	"useLogin",
	"useLogout",
]);

export { AUTH_SERVICE_KEYS };
